import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { useStoreActions } from '../store/actions';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import cls from '../styles/Apartments.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface Type {
  [x: string]: {
    rooms: string;
    square: string;
  };
}

const apartments: Type = {
  '1': {
    rooms: '4',
    square: '144.4'
  },
  '2': {
    rooms: '2',
    square: '83.9'
  },
  '3': {
    rooms: '1',
    square: '49.9'
  },
  '4': {
    rooms: '3',
    square: '118.8'
  },
  '5': {
    rooms: '1',
    square: '44.2'
  },
  '6': {
    rooms: '4',
    square: '157.1'
  },
  '7': {
    rooms: '2',
    square: '90.5'
  },
  '8': {
    rooms: '3',
    square: '113.7'
  },
};

const ApartmentsA = () => {
  const {
    incrementSelectedFloor,
    decrementSelectedFloor,
    toggleSelectedObject,
    onHoverOverApartment,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor, selectedObject, selectedApartment } = useSnapshot(AppStore);

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(21)} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="Назад" />
        <p>К выбору блока</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={incrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>

          <div className={cls.selectionBody}>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Блок</p>
              <p>{selectedObject}</p>
            </div>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.imageWrapper}>
            <LazyLoadImage
              src={`./images/apartments/blockA/${selectedApartment}.png`}
              alt=""
              effect="blur"
            />
          </div>

          <div className={cls.textWrapper}>
            <p>{apartments[selectedApartment].rooms}-комнатные</p>

            <div className={cls.detailItem}>
              <div>Объект:</div>
              <div>«Da Vinchi»</div>
            </div>

            <div className={cls.detailItem}>
              <div>Площадь квартиры:</div>
              <div>{apartments[selectedApartment].square} кв.м</div>
            </div>

            <div className={cls.detailItem}>
              <div>Адрес:</div>
              <div>Бишкек, мкрн Асанбай</div>
            </div>
          </div>
        </div>
      </div>

      <div className={cls.imageContainer}>
        <div onClick={() => goPrevPage(21)} className={cls.navigationButton}>
          <img src="./images/arrow.png" alt="" />
          <p>К выбору этажа</p>
        </div>

        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a4-1">
              <path onMouseOver={() => onHoverOverApartment(1)} fill="#3292ffcc" d="m 804.04332,224.25725h 154.47417 v 173.29006h -7.91967 v 24.37344h -6.29901 v 30.80766H 1140.4469 V 269.43539 h 4.6077v -34.50112 h -37.3935V 134.961 H 803.90787" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a2-1">
              <path onMouseOver={() => onHoverOverApartment(2)} fill="#3292ffcc" d="m 943.91228,459.80506v 28.75624 h -38.66037v 21.75963 h -6.69132v 9.75839 h 19.15619v -2.72694 h 31.70913v -2.29874 h 12.75577v 0.63103 h 22.67192v 3.3805 h -22.87006v 8.88955 h -3.09156V 668.38143 H 1140.2666V 459.53449" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a1-2">
              <path onMouseOver={() => onHoverOverApartment(3)} fill="#3292ffcc" d="M 808.9197,488.59317V 668.2581 H 952.58105V 526.2093 H 895.9914v -37.54613" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a3-2">
              <path onMouseOver={() => onHoverOverApartment(4)} fill="#3292ffcc" d="M 802.7909,668.34824H 657.00323 V 277.07663h 143.02426 v 31.98325h 2.65332" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a1-1">
              <path onMouseOver={() => onHoverOverApartment(5)} fill="#3292ffcc" d="m 351.25801,242.27273v 142.49439 h 4.96004v 3.35788 h 138.60202v -3.31528 h 3.64602V 242.21875" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a4-2">
              <path onMouseOver={() => onHoverOverApartment(6)} fill="#3292ffcc" d="m 504.33744,242.26948v 152.01533 h -74.60773v 256.93554 h 71.75556v -15.73051 h 146.92854v -26.07506 h 1.34166V 271.0263 h 3.40304V 257.20462 H 578.4719v -14.98585" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a2-2">
              <path onMouseOver={() => onHoverOverApartment(7)} fill="#3292ffcc" d="m 423.50781,456.86719h -28.34375 v -5.34375H 267.2035 v 5.35937h -64.31288 v 184.67296h -5.01121 v 9.92712H 423.5" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/a3-1">
              <path onMouseOver={() => onHoverOverApartment(8)} fill="#3292ffcc" d="M 123.19678,257.17142V 276.875 H 52.914062v 6.98437 h -2.050781v 25.02344 H 47.199378V 603.7808 h 3.71231v 25.03951 h 2.084406v 6.98438 H 192.07893v -6.99894 h 2.04398v -25.09124 h 2.66615V 308.96147 h -2.68825v -25.08572 h -2.32019v -26.64528" />
            </a>
          </svg>

          <LazyLoadImage
            src="./images/floors/blockA.png"
            alt=""
            effect="blur"
          />
        </div>
      </div>
    </div >
  );
};

export default ApartmentsA;
